import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { AdsenseComponent } from "../adsense/adsense.component";

@Component({
  selector: 'otw-home-banners-wrapper',
  standalone: true,
  imports: [CommonModule, AdsenseComponent],
  templateUrl: './home-banners-wrapper.component.html',
  styles: ``,
})
export class HomeBannersWrapperComponent {
  containerClass = input<string>('');
}
